export class Company {
  forEach(arg0: (progId: any) => void) {
    throw new Error('Method not implemented.');
  }
  id?: string;
  companyName: string;
  companyLegalName: string;
  rfc: string;
  companyPhone: string;
  nacionalidad: string;
  contactName: string;
  contactLastName: string;
  contactSecondLastName: string;
  contactPhone: string;
  contactEmail: string;
  contactJobPosition: string;
  dateCreated: number;
  userWithNoApp: boolean;
  isBroker: boolean;
  isRequest: boolean;
  cuentaClabeSTP: string;
  docs?: {
    logo: string;
    rfc: string;
    actaConstitutiva: string;
    comprobanteDomicilio: string;
    identificacion: string;
    id: string;
    efos: string,
    rpc: string
  };
  address?: {
    street: string;
    number: string;
    numberInt: string;
    neighborhood: string;
    city: string;
    state: string;
    country: string;
    zip: string;
  };
  bank?: {
    name: string;
    titular: string;
    account: number;
    clabe: number;
  };
  giro?: {
    name: string;
  };
  actaConstitutiva?: {
    escrituraPublica: number;
    fechaConstitucion: string;
    nombreFedatario: string;
    notarioPublicoTitular: string;
    registroPublico: string;
    ciudad: string;
    folioMercantil: string;
    fechaInscripcion: string;
  };
  modificacionesEstatutos?: {
    escrituraPublica: number;
    fechaConstitucion: string;
    nombreFedatario: string;
    notarioPublicoTitular: string;
    registroPublico: string;
    ciudad: string;
    folioMercantil: string;
    fechaInscripcion: string;
  };
  administrador?: {
    nombreAdministrador: string;
    rfcAdministrador: string;
  };
  accionistas?: {
    nombreAccionista: string;
    rfc: string;
  }[];
  representanteLegal?: {
    name: string;
    fechaNacimiento: string;
    email: string;
    rfc: string;
    curp: string;
    tipoDocumentoId: string;
    autoridadQueEmiteDocumentoId: string;
    numeroDocumentoId: string;
    actividad: string;
  };
  poderRepresentanteLegal?: {
    escrituraPublica: number;
    fechaConstitucion: string;
    nombreFedatario: string;
    notarioPublicoTitular: string;
    registroPublico: string;
    ciudad: string;
    folioMercantil: string;
    fechaInscripcion: string;
  };
  programs: {
    programName: string;
    programId: string;
    cardTypeName: string;
    cardTypeId: number;
    agreementNNumber: number;
  }[];

  constructor(formData?: any) {
    let data: any = !formData ? {} : formData;

    this.id = data.id || null;
    this.companyName = data.companyName || null;
    this.companyLegalName = data.companyLegalName || null;
    this.rfc = data.rfc || null;
    this.companyPhone = data.companyPhone || null;
    this.nacionalidad = data.nacionalidad || null;
    this.contactName = data.contactName || null;
    this.contactLastName = data.contactLastName || null;
    this.contactSecondLastName = data.contactSecondLastName || null;
    this.contactPhone = data.contactPhone || null;
    this.contactEmail = data.contactEmail || null;
    this.contactJobPosition = data.contactJobPosition || null;
    this.dateCreated = data.dateCreated || null;
    this.isRequest = data.isRequest || null;
    this.docs = data.docs || {
      logo: null,
      rfc: null,
      actaConstitutiva: null,
      comprobanteDomicilio: null,
      identificacion: null,
      id : null,
      efos: null,
      rpc: null
    };
    this.address = data.address || {
      street: null,
      number: null,
      numberInt: null,
      neighborhood: null,
      city: null,
      state: null,
      country: null,
      zip: null,
    };
    this.bank = data.bank || {
      name: null,
      titular: null,
      account: null,
      clabe: null,
    };
    this.giro = data.giro || {
      name: null,
    };
    this.actaConstitutiva = data.actaConstitutiva || {
      escrituraPublica: null,
      fechaConstitucion: null,
      nombreFedatario: null,
      notarioPublicoTitular: null,
      registroPublico: null,
      ciudad: null,
      folioMercantil: null,
      fechaInscripcion: null,
    };
    this.modificacionesEstatutos = data.modificacionesEstatutos || {
      escrituraPublica: null,
      fechaConstitucion: null,
      nombreFedatario: null,
      notarioPublicoTitular: null,
      registroPublico: null,
      ciudad: null,
      folioMercantil: null,
      fechaInscripcion: null,
    };
    this.administrador = data.administrador || {
      nombreAdministrador: null,
      rfcAdministrador: null,
    };
    this.accionistas = data.accionistas || [];
    this.representanteLegal = data.representanteLegal || {
      name: null,
      fechaNacimiento: null,
      email: null,
      rfc: null,
      curp: null,
      tipoDocumentoId: null,
      autoridadQueEmiteDocumentoId: null,
      numeroDocumentoId: null,
      actividad: null
    };
    this.poderRepresentanteLegal = data.poderRepresentanteLegal || {
      escrituraPublica: null,
      fechaConstitucion: null,
      nombreFedatario: null,
      notarioPublicoTitular: null,
      registroPublico: null,
      ciudad: null,
      folioMercantil: null,
      fechaInscripcion: null,
    };
    this.programs = data.programs || [];
  }
}

export class Accionista {
  forEach(arg0: (progId: any) => void) {
    throw new Error('Method not implemented.');
  }
  nombreAccionista: string;
  rfc: string;

  constructor(formData?: any) {
    let data: any = !formData ? {} : formData;

    this.nombreAccionista = data.nombreAccionista || null;
    this.rfc = data.rfc || null;
  }
}
